import React from "react";
import { Alert } from "@mui/material";

function AlertError({ children }) {
  return (
    <Alert
      sx={{
        margin: "1rem 0rem",
        border: `1px solid  "#5bb65f"`,
        borderRadius: "12px",
        fontFamily: "ITC",
      }}
      severity="success">
      {children}
    </Alert>
  );
}

export default AlertError;
